import _ from 'underscore';
import axios from 'axios';
import Environment from '../environment';
import stgConfig from "../../../../config";
import { hamletUser } from './hamlet-user';

export class HamletApi {
  baseDomain: string;

  constructor() {
    this.baseDomain = this.getBaseDomain();
  }

  getBaseDomain() {
    if (!Environment.isProduction()) {
      return  `${window.location.hostname.indexOf('qa-wac') > -1 ? 'https://qa-wac.internal.atlassian.com' : stgConfig.stgWacInternalUrl}`;
    }

    return 'https://www.atlassian.com';
  }

  getHamletPath() {
    if (!Environment.isProduction()) {
      return `${this.baseDomain}/apis/stg/hamlet`;
    }

    return `${this.baseDomain}/hamlet`;
  }

  getCofsPath() {
    if (!Environment.isProduction()) {
      return `${this.baseDomain}/apis/stg/cofs`;
    }

    return `${this.baseDomain}/apis/prod/cofs`;
  }

  getCnasPath() {
    if (!Environment.isProduction()) {
      return `${this.baseDomain}/apis/stg/cnas`;
    }

    return `${this.baseDomain}/apis/prod/cnas`;
  }

  getBxpPath() {
    return `${this.baseDomain}/endpoint`;
  }

  hamletRequest(params, useCofsPath) {

    let basePath = useCofsPath ? this.getCofsPath() : this.getHamletPath();

    let request = {
      url: `${basePath}${params.url}`,
      method: params.method || 'GET',
      headers: params.headers || {},
      params: params.params
    };

    if (request.method === 'GET') {
      request.params = {cacheBuster: new Date().getTime(), ...params.params };
    }

    if (request.method === 'POST') {
      request.headers['Content-Type'] = 'application/json';
      request.data = params.data || '';
    }

    if (params.authenticated && hamletUser.getToken()) {
      request.headers['ATL-XSRF-Token'] = hamletUser.getToken();
      request.withCredentials = true;
    }

    return axios(request);
  }

  bxpRequest(params) {

    let request = {
      url: `${params.url.startsWith('http') ? '' : this.getBxpPath()}${params.url}`,
      method: params.method || 'GET',
      headers: params.headers || {},
      params: params.params
    };

    if (request.method === 'GET') {
      request.params = { cacheBuster: new Date().getTime(), ...params.params };
    }

    if (request.method === 'POST') {
      request.headers['Content-Type'] = 'application/json';
      request.data = params.data || '';
    }

    if (params.authenticated && hamletUser.getToken()) {
      request.withCredentials = true;
    }

    return axios(request);
  }

  get(data) {
    let options = { method: 'GET' };

    if (_.isString(data)) {
      options.url = data;
    } else if (_.isObject(data)) {
      Object.assign(options, data);
    }

    return this.hamletRequest(options);
  }

  post(data) {
    let options = { method: 'POST' };

    if (_.isString(data)) {
      options.url = data;
    } else {
      Object.assign(options, data);
    }

    return this.hamletRequest(options);
  }

  /**
   * Generic request wrapper
   */
  request(options) {
    return axios(options);
  }

}

export let hamletApi = new HamletApi();
